import ConnectedModal from 'components/ConnectedModal';
import { useEventTracking } from 'context/EventTrackingContext';
import { useConnectedModal } from 'context/ModalContext';
import ContinueListeningContents from './ContinueListeningContents';

export interface ContinueListeningOverlayProps {}

const ContinueListeningOverlay: React.FC<
  ContinueListeningOverlayProps
> = () => {
  const { trackPlayback } = useEventTracking();
  const { params } = useConnectedModal({ name: 'ContinueListening' });

  return (
    <ConnectedModal
      name="ContinueListening"
      onAfterClose={() => {
        trackPlayback('play', {
          source: 'WidgetTrafficCTA',
          podcastName: params.podcastName,
          episodeName: params.episodeName,
          podcastId: params.podcastId,
          remoteEpisodeId: params.episodeId,
        });
      }}
    >
      <ContinueListeningContents />
    </ConnectedModal>
  );
};

export default ContinueListeningOverlay;
